import type { Preferences, ServerPreference } from '../../../shared/domain/serverPreferences/types.no-deps'
import { DS_getData } from '../DS/DS.Data'
import { Serv_send } from '../Serv/Serv.socketClient'

export interface Cust_TServerPrefs extends Partial<Preferences> {
    minSpaceForReport?: number // in bytes
    supportMessage?: string // Overrides explanatory text in the contact section of troubleshooting
    supportNumber?: string
    supportEmail?: string
    supportWebsite?: string // include the https://
}

export async function Cust_serverPrefsFetch() {
    const serverPrefs: Partial<Preferences> = {}
    try {
        const result = await Serv_send('serverPreferences.get', {})

        result.preferences.forEach(function <T extends keyof Partial<Preferences>>(pref: ServerPreference<T>) {
            serverPrefs[pref.type as T] = pref.data as ServerPreference<T>['data']
        })
    } catch (_) {
        // Do nothing
    }
    return serverPrefs
}

export function Cust_hasSingleLocation() {
    if (ENV.locationPreferenceOverride != null) return ENV.locationPreferenceOverride === 'single'

    const { serverPrefs } = DS_getData()

    return serverPrefs.location && serverPrefs.location.single
}

export function Cust_hasCacheFlowImages() {
    const { serverPrefs } = DS_getData()
    return serverPrefs.cache?.flowImages?.enabled
}

export function Cust_hasCleanupFlowImages() {
    const { serverPrefs } = DS_getData()
    return serverPrefs.cache?.flowImages?.cleanup
}

export function Cust_canCacheFlowImages() {
    return Cust_hasSingleLocation() && Cust_hasCacheFlowImages()
}

export function Cust_canCleanupFlowImages() {
    return Cust_hasSingleLocation() && Cust_hasCleanupFlowImages()
}

export function Cust_hasLogsDisabled() {
    const { serverPrefs } = DS_getData()
    return serverPrefs?.sendLogs?.disabled
}
